export const SOIL_CATEGORY_VALUES: Record<string, string[]> = {
  biomaterials: ['yes', 'no'],
  plant_materials: ['yes', 'no'],
  brightness: ['bright', 'dark'],
  color: ['gray', 'black', 'brown', 'yellow', 'red', 'green', 'blue', 'white', 'mixed'],
  grainsize: ['finer', 'sand'],
  gravel: ['high', 'medium', 'low'],
  mixed_waste: ['low', 'medium', 'high'],
  sticky: ['yes', 'no'],
  wet: ['yes', 'no'],
};
